import {
  RobotMissionState,
  RobotSchedulingState,
} from '@common/interfaces/robot/status/robot-state';
import RobotStatus, { isRobotStatus } from './robot-status';

interface RobotSituation {
  status: RobotStatus | null;
  mission?: RobotMissionState | null;
  scheduling?: RobotSchedulingState | null;
}

export const isRobotSituation = (input: any): input is RobotSituation => {
  return 'status' in input && isRobotStatus(input.status);
};

export default RobotSituation;
